/*
  LIORIVE — long colour lists on the product page (every width).
  With many colours (17 on some pieces) the swatches filled three or four rows before the
  "Ajouter au panier" button. The list now shows two full rows plus the selected colour, and a
  "Voir les N coloris" button reveals the rest. Two rows are measured from the real layout, so the
  limit follows the column width (5 per row on a phone, 7 at 1440).
  Dawn re-renders the variant picker after each choice, so the state is re-applied on every render.
*/
(() => {
  let expanded = false;

  // Swatches per row, read from the first row's positions (all labels are visible at this point).
  const perRow = (labels) => {
    const top = labels[0].getBoundingClientRect().top;
    const n = labels.findIndex((l) => l.getBoundingClientRect().top > top + 2);
    return n > 0 ? n : 5;
  };

  const apply = (fieldset) => {
    const labels = Array.from(fieldset.querySelectorAll('.swatch-input__label'));
    labels.forEach((l) => l.classList.remove('lr-sw-extra'));
    const LIMIT = perRow(labels) * 2;
    if (labels.length <= LIMIT + 1) {
      fieldset.classList.remove('lr-sw-collapsed');
      fieldset.querySelector('.lr-sw-more')?.remove();
      return;
    }
    labels.forEach((label, i) => {
      const input = document.getElementById(label.htmlFor);
      label.classList.toggle('lr-sw-extra', i >= LIMIT && !(input && input.checked));
    });
    fieldset.classList.toggle('lr-sw-collapsed', !expanded);
    let button = fieldset.querySelector('.lr-sw-more');
    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'lr-sw-more';
      button.addEventListener('click', () => {
        expanded = !expanded;
        document.querySelectorAll('fieldset.product-form__input--swatch').forEach(apply);
      });
      fieldset.appendChild(button);
    }
    button.textContent = expanded ? 'Afficher moins de coloris' : `Voir les ${labels.length} coloris`;
    button.setAttribute('aria-expanded', String(expanded));
  };

  const run = () => document.querySelectorAll('fieldset.product-form__input--swatch').forEach(apply);
  run();
  new MutationObserver((records) => {
    if (records.some((r) => Array.from(r.addedNodes).some((n) => n.nodeType === 1 && (n.matches?.('fieldset.product-form__input--swatch, variant-selects') || n.querySelector?.('fieldset.product-form__input--swatch'))))) run();
  }).observe(document.body, { childList: true, subtree: true });
  let resizeTimer;
  window.addEventListener('resize', () => { clearTimeout(resizeTimer); resizeTimer = setTimeout(run, 150); });
  document.addEventListener('change', (e) => {
    if (e.target.closest && e.target.closest('fieldset.product-form__input--swatch')) run();
  });
})();
